import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { useSelector } from "react-redux";

const SuccessMsg = ({ msg }) => {
  const adminSuccessMsg = useSelector((state) => state.adminSuccessMsg);
  const open = adminSuccessMsg === "" ? false : true;
  return (
    <Snackbar
      open={open}
      autoHideDuration={1000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert severity="success">{adminSuccessMsg}</Alert>
    </Snackbar>
  );
};

export default SuccessMsg;
